<input [ngModel]="respuesta?.alternativa" class="form-control" [disabled]="true" type="text" />
